import { render, staticRenderFns } from "./ClaimForm.vue?vue&type=template&id=f99947ee&scoped=true"
import script from "./ClaimForm.ts?vue&type=script&lang=ts&external"
export * from "./ClaimForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99947ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f99947ee')) {
      api.createRecord('f99947ee', component.options)
    } else {
      api.reload('f99947ee', component.options)
    }
    module.hot.accept("./ClaimForm.vue?vue&type=template&id=f99947ee&scoped=true", function () {
      api.rerender('f99947ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P48/ClaimForm/ClaimForm.vue"
export default component.exports